import axios from "axios";

const GetLeaveBalance = async (month) => {
  let formData = new FormData();
  formData.append("P_YEAR", month);

  let config = {
    method: "post",
    url: "Leave/DTSGetLeaveBalance",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

const GetNotEnteredLeave = async (month) => {
  let formData = new FormData();
  formData.append("P_YEAR", month);

  let config = {
    method: "post",
    url: "Leave/DTSGetNotEnteredLeave",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

const GetPunctuality = async (month) => {
  let formData = new FormData();
  formData.append("P_YEAR", month);

  let config = {
    method: "post",
    url: "Leave/DTSGetPunctuality",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

const GetLeaveSummary = async (month) => {
  let formData = new FormData();
  formData.append("P_YEAR", month);

  let config = {
    method: "post",
    url: "Leave/DTSGetLeaveSummary",
    data: formData,
  };

  return axios.request(config).then((response) => {
    return response;
  });
};

export default {
  GetLeaveBalance,
  GetNotEnteredLeave,
  GetPunctuality,
  GetLeaveSummary,
};
